export const LogoMark = ({ className = "h-10 w-10" }) => (
  <img
    src="/images/logo-mark.png"
    alt="Logo CV Mitra Bangun Utama"
    className={className}
  />
);

export const Logo = ({ dark = true }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark className="h-10 w-10 shrink-0" />
    <div className="leading-none">
      <p
        className={`font-display whitespace-nowrap text-lg font-semibold uppercase tracking-wide ${
          dark ? "text-white" : "text-[#141619]"
        }`}
      >
        CV Mitra Bangun Utama
      </p>
      <p className="font-tech mt-0.5 text-[9px] uppercase tracking-[0.24em] text-[#DF9F00]">
        General Supplier &amp; Scaffolding
      </p>
    </div>
  </div>
);
